export default "__VITE_ASSET__BHHhmZC7__"